import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-3bec6cae");

var _hoisted_1 = {
  class: "dialog-info-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 1,
  class: "modal-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UpdateAdd = _resolveComponent("UpdateAdd");

  var _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_overlay, {
    show: $props.show,
    "z-index": "3"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString($options.titleInfo), 1), $props.isSlot ? _renderSlot(_ctx.$slots, "content", {
        key: 0
      }, undefined, true) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_UpdateAdd, {
        coverImgUrl: $props.coverImgUrl,
        item: $props.item
      }, null, 8, ["coverImgUrl", "item"])]))])];
    }),
    _: 3
  }, 8, ["show"])]);
}